import styled from "styled-components";

const Item = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 13px 20px;

  border-radius: 5px;

  background-color: var(--grey-4);

  &:hover {
    background-color: var(--grey-2);
  }

  h3 {
    font-size: 14px;

    font-weight: 700;
    color: var(--grey-0);
  }

  div {
    display: flex;

    gap: 25px;

    font-size: 12px;
    font-weight: 400;

    color: var(--grey-1);

    & > button {
      background-color: transparent;
      color: var(--grey-0);
    }
  }
`;

export default Item;
